module.exports = __webpack_public_path__ + "img/cf_bg.ef99ba36.png";